<script>
    export default {
        props: {
            value: Array,
            type: {
                type: Number,
                default: 1,
            },
            typeDisabled: {
                type: Boolean,
                default: false,
            },
            typeShow: {
                type: Boolean,
                default: true,
            },
            page: {
                type: String,
                default: 'payments'
            }
        },
        data() {
            return {
                pickerOptions: {
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: 'Сегодня',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Неделя',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Месяц',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '3 месяца',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ],
                },
            }
        },
        methods: {
            change(v) {
                this.$emit('change_type', v);
            },
            input(v) {
                this.$emit('input', v);
                this.$emit('change', v);
            },
        },
        computed: {
            list() {
                switch (this.page) {
                    case 'invoices':
                        return [
                            {
                                label: 'Оплаты',
                                value: 1,
                            },
                            {
                                label: 'Реализации',
                                value: 2,
                            },
                            {
                                label: 'Создания',
                                value: 3,
                            },
                        ];
                    case 'regulars':
                        return [
                            {
                                label: 'Платежа',
                                value: 1,
                            },
                            {
                                label: 'Создания',
                                value: 2,
                            },
                            {
                                label: 'Оплаты',
                                value: 3,
                            },
                        ];
                    case 'payments':
                        return [
                            {
                                label: 'Создания',
                                value: 1,
                            },
                            {
                                label: 'Платежа',
                                value: 2,
                            },
                            {
                                label: 'Изменения',
                                value: 3,
                            },
                        ];
                    case 'statements':
                        return [
                            {
                                label: 'Загрузки',
                                value: 1,
                            },
                            {
                                label: 'Платежа',
                                value: 0,
                            },
                        ];
                    case 'certificates':
                        return [
                            {
                                label: 'Выдачи',
                                value: 1,
                            },
                            {
                                label: 'Начала',
                                value: 2,
                            },
                            {
                                label: 'Окончания',
                                value: 3,
                            },
                        ];
                    default:
                        return [
                            {
                                label: 'Создания',
                                value: 1,
                            },
                            {
                                label: 'Платежа',
                                value: 2,
                            },
                            {
                                label: 'Изменения',
                                value: 3,
                            },
                        ]
                }
            },
        },
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="input-select-date">
        <div class="el-input-group el-input--mini el-input-group--prepend" v-if="typeShow">
            <div class="el-input-group__prepend">
                <el-select :value="type" :disabled="typeDisabled" @change="change">
                    <el-option v-for="item in list" :value="item.value" :key="item.value" :label="item.label"></el-option>
                </el-select>
            </div>
            <el-date-picker
                    :value="value"
                    @input="input"
                    type="daterange"
                    format="dd.MM.yyyy"
                    range-separator="По"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                    :clearable="false"
            ></el-date-picker>
        </div>
        <el-date-picker
                v-if="!typeShow"
                :value="value"
                @input="input"
                type="daterange"
                format="dd.MM.yyyy"
                range-separator="По"
                value-format="dd.MM.yyyy"
                :picker-options="pickerOptions"
                :clearable="false"
        ></el-date-picker>
    </div>
</template>
<style lang="scss">
    .input-select-date {
        height: 28px;
        .el-select {
            width: 120px;
        }
        .el-date-editor {
            .el-range-input {
                width: 80px;
            }
            .el-input__icon {
                line-height: 20px;
            }
        }
        .el-input-group__prepend {
            border: none;
            .el-select {
                .el-input {
                    &.is-disabled {
                        .el-input__inner {
                            cursor: default;
                        }
                        .el-input__suffix {
                            display: none;
                        }
                    }
                    &.is-focus {
                        .el-input__inner {
                            border: 1px solid #6db234;
                            border-radius: 4px 0 0 4px;
                        }
                    }
                    .el-input__inner {
                        border: 1px solid #d8dce5;
                        border-radius: 4px 0 0 4px;
                    }
                }
            }
        }
    }
</style>
